export enum RowType {
  ROW_TYPE_TRANSACTION = 1,
  ROW_TYPE_POSITION = 2,
}
